export const tiposUsuario = [
    {
        id: "CLIENTE",
        nome: "Cliente",
    },
    {
        id: "OPERADOR",
        nome: "Operador",
    },
    {
        id: "AGENTE",
        nome: "Agente",
    },
    {
        id: "OPERADOR PARCEIRO",
        nome: "Operador Parceiro",
    },
    {
        id: "ADMINISTRADOR",
        nome: "Administrador",
    },
];

export const tiposCredito = [
    { id: "TODOS", nome: "Todos", value: "TODOS" },
    { id: "CONSIGNADO", nome: "Consignado", value: "CONSIGNADO" },
    { id: "PESSOAL", nome: "Pessoal", value: "PESSOAL" },
    { id: "EMPRESARIAL", nome: "Empresarial", value: "EMPRESARIAL" },
];